// extracted by mini-css-extract-plugin
export default {"datasetLabel":"SearchPop_datasetLabel__qtH-q","datasetContainer":"SearchPop_datasetContainer__L9d2g"};